<div
  class="card-container dataset-card overflow-hidden d-flex flex-column h-100"
>
  <div>
    <app-card-header-image>
      <img
        #datasetimage
        imagePlaceholder
        class="image"
        width="100%"
        height="100%"
        [src]="datasetListItem.imageUrl"
        [alt]="datasetListItem.name || 'Dataset Name'"
        (error)="datasetimage.src = 'assets/images/fallback-image.png'"
      />
      <span updatedOn>
        {{ datasetListItem.updatedAt | lastUpdatedDays }}
      </span>
    </app-card-header-image>

    <div class="dataset-card_content">
      <div class="fw-500 dataset-header text-base">
        {{ datasetListItem.name }}
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex justify-content-start align-items-center gap-1 my-1">
          <img
            class="cursor-pointer"
            width="12"
            height="12"
            src="assets/images/info-line.svg"
            alt=""
            title="Data Quality Score (Beta)"
          />
          <ng-container *ngIf="!+datasetListItem?.version_score; else hasScore">
            <span [title]="datasetListItem?.version_score + ' stars'">-</span>
          </ng-container>
          <ng-template #hasScore>
            <app-star-rating
              [starSize]="'fa-xs'"
              [rating]="
                +(datasetListItem?.version_score | number : '1.2-2') || 0
              "
            ></app-star-rating>
          </ng-template>
        </div>

        <span
          *ngIf="linkedArtefact"
          [innerHTML]="linkArtefactIconGreenSvg | safeHTML"
          class="link_artefact_icon"
          matTooltip="Dataset used to train this model."
        ></span>
      </div>

      <div class="secondary-color text-s description">
        {{ datasetListItem.shortDescription }}
      </div>
    </div>
  </div>

  <div class="mt-auto">
    <div class="px-3 pb-2">
      <div
        *ngIf="datasetListItem.tags?.length"
        class="d-flex align-items-center gap-2 chip_overflow mb-3"
      >
        <ng-container *ngFor="let tag of datasetListItem.tags; let i = index">
          <div *ngIf="tag" class="flex-shrink-0">
            <app-card-chips>{{ tag }}</app-card-chips>
          </div>
        </ng-container>
      </div>

      <!-- Optional: Card owner details -->

      <!-- <div class="mb-3">
        <app-card-owner-detail>
          <img
            class="rounded-circle"
            imagePlaceholder
            imageFallBack="assets/images/fallback-image.png"
            profileImage
            width="24px"
            height="24px"
            [alt]="datasetListItem?.currentOwner?.name || 'Username'"
            [title]="datasetListItem?.currentOwner?.name || 'Username'"
            [src]="datasetListItem?.currentOwner?.profilepic"
          />
          <span>{{ datasetListItem?.currentOwner?.name || "Username" }}</span>
        </app-card-owner-detail>
      </div> -->

      <app-card-activities
        [downloadCount]="datasetListItem?.stats?.downloads"
        [viewCount]="datasetListItem?.stats?.views"
        [saveFileCount]="datasetListItem?.stats?.size"
      ></app-card-activities>
    </div>

    <hr class="m-0 px-0 text-gray" />

    <div class="org-logo-container">
      <span
        [title]="
          datasetListItem?.currentOwner?.organization?.name || '' | uppercase
        "
      >
        {{ datasetListItem?.currentOwner?.organization?.name | uppercase }}
      </span>
    </div>

    <hr class="m-0 px-0 text-gray" />

    <div class="m-3 d-flex justify-content-between align-items-center">
      <a
        role="button"
        class="btn-tertiary-bordered btn h-auto px-3 py-2"
        (click)="onDatasetClick(datasetListItem.id)"
      >
        View Details
      </a>
    </div>
  </div>
</div>
